import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/v1/terms";

export const terms = {
    // ...example,
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
}
